import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-petrolDark py-12 text-mutedDark" data-id="element-108" data-mp="3gfsp4jdu96q5">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-109" data-mp="3ghc0pwojutll">
        <p className="font-display text-xl font-bold text-white" data-id="element-110" data-mp="32ovzn1f7l5nb">MEGAPACK INSTRUMENTACIÓN QUIRÚRGICA LISTO™</p>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed" data-id="element-111" data-mp="36pzb7bq84fiq">
          Hecho por especialistas, para docentes de Instrumentación Quirúrgica de toda Argentina.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-sm font-semibold leading-relaxed text-aqua" data-id="element-112" data-mp="37o5kstgztcb">
          “La próxima clase que des, podés entrar al aula sabiendo que el instrumentador quirúrgico es el primer escudo de
          seguridad del paciente en el quirófano.”
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2" data-id="element-113" data-mp="29yno3sf6hjhp">
          <a href="mailto:packcentral23@gmail.com" className="inline-flex items-center gap-2 text-sm font-bold text-aqua hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-aqua" data-id="element-114" data-mp="2ey0akc250ojr">
            <MailIcon className="h-4 w-4" data-id="element-115" data-mp="3gbqyeggtmnbf" /> packcentral23@gmail.com
          </a>
          <a href="https://instagram.com/centralpack.ar" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-bold text-aqua hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-aqua" data-id="element-116" data-mp="3v7zuj95f0kjm">
            <InstagramIcon className="h-4 w-4" data-id="element-117" data-mp="335slg3f1hfy" /> @centralpack.ar
          </a>
        </div>
        <p className="mt-8 border-t border-lineDark pt-6 text-xs" data-id="element-118" data-mp="hrs5lb5klx40">
          © MEGAPACK INSTRUMENTACIÓN QUIRÚRGICA LISTO™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}